module.exports = __webpack_public_path__ + "static/media/poster.792cd6e0.jpg";